import React from 'react';
import MicroLabel from './MicroLabel';

/**
 * A micro-label above a monospace figure — the unit the chapter 03 stat row and
 * the chapter 07 stat column are both built from.
 *
 * @param {Object} props
 * @param {string} props.label
 * @param {React.ReactNode} props.value
 * @param {boolean} [props.accent=false] - Render the figure in the deep accent
 * @param {string} [props.valueClassName]
 */
function StatCell({ label, value, accent = false, valueClassName = '' }) {
  return (
    <div>
      <MicroLabel>{label}</MicroLabel>
      <div
        className={`story-stat-value ${accent ? 'story-stat-value-accent' : ''} ${valueClassName}`.trim()}
      >
        {value}
      </div>
    </div>
  );
}

export default StatCell;
